// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__1KjwT","empty":"ModalGraph_empty__1gMJ2"};